import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import { showAlert } from './alert'

import getString from '../config/strings'
import UserService from '../services/userService'
import { USER_SCOPES, MIN_PASSWORD_SIZE, PASSWORD_SPECIAL_CHARS } from '../config/config'

const styles = theme => ({
  button: {
    margin: theme.spacing(1),
  },
})

class Login extends PureComponent {
  constructor (props, context, updater) {
    super(props, context, updater)

    this.emptyValues = {
      password: {
        value: '',
        error: false,
        message: ''
      },

      password2: {
        value: '',
        error: false,
        message: ''
      },

      activationCode: {
        value: '',
        error: false,
        message: ''
      },

      email: {
        value: '',
        error: false,
        message: ''
      }
    }

    this.state = Object.assign({dialogType: 'login'}, this.emptyValues)
  }

  setActivationCode (code) {
    code = code.replace(/(^\s+|\s+$)/g, '')
    if (code !== '') {
      this.setState({activationCode: {value: code, error: false, message: ''}})
    } else {
      this.setState({activationCode: {value: code, error: true, message: getString('ERROR_ACTIVATIONCODE_EMPTY')}})
    }
  }

  setEmail (email) {
    email = email.replace(/(^\s+|\s+$)/g, '')
    if (email.match(/^[A-Za-zäöüßÄÖÜ0-9!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-zäöüßÄÖÜ0-9!#$%&'*+/=?^_`{|}~-]+)*@([A-Za-zäöüßÄÖÜ0-9][A-Za-zäöüßÄÖÜ0-9-]*\.)+[A-Za-zäöüßÄÖÜ0-9]{2,}$/)) {
      this.setState({email: {value: email, error: false, message: ''}})
    } else {
      this.setState({email: {value: email, error: true, message: getString('ERROR_INVALID_EMAIL')}})
    }
  }

  validatePassword (value) {
    let hasUpperCase = value !== value.toLowerCase()  // mindestens ein Großbuchstabe
    let hasLowerCase = value !== value.toUpperCase()  // mindestens ein Kleinbuchstabe
    let hasDigit = value.match(/\d/)                  // mindestens eine Ziffer
    let hasSpecialChar = false
    for (let i = 0, l = PASSWORD_SPECIAL_CHARS.length; i < l; i++) {
      if (value.indexOf(PASSWORD_SPECIAL_CHARS.charAt(i)) >= 0) {
        hasSpecialChar = true
        break
      }
    } // mindestens ein Sonderzeichen
    return (hasUpperCase && hasLowerCase && hasDigit && hasSpecialChar)
  }

  setPassword (password) {
    password = password.replace(/^\s+/g, '')
    if (password.length >= MIN_PASSWORD_SIZE) {
      if (this.validatePassword(password)) {
        this.setState({password: {value: password, error: false, message: ''}})
        if (this.state.password2.value)
          this.setPassword2(this.state.password2.value)
      } else {
        this.setState({password: {value: password, error: true, message: getString('ERROR_PASSWORD_POLICY')}})
      }
    } else {
      this.setState({password: {value: password, error: true, message: getString('ERROR_PASSWORD_SHORT')}})
    }
  }

  setPassword2 (password2) {
    password2 = password2.replace(/^\s+/g, '')
    if (password2.length >= MIN_PASSWORD_SIZE) {
      if (this.validatePassword(password2)) {
        if (password2 === this.state.password.value) {
          this.setState({password2: {value: password2, error: false, message: ''}})
        } else {
          this.setState({password2: {value: password2, error: true, message: getString('ERROR_PASSWORD_NOTMATCH')}})
        }
      } else {
        this.setState({password2: {value: password2, error: true, message: getString('ERROR_PASSWORD_POLICY')}})
      }

    } else {
      this.setState({password2: {value: password2, error: true, message: getString('ERROR_PASSWORD_SHORT')}})
    }
  }

  async login (event) {
    event.preventDefault()
    if (this.state.email.error || this.state.password.error) {
      showAlert(getString('invalid inputs'), getString('LOGIN_ERROR'))
    } else {
      try {
        let auth = await UserService.login(this.state.email.value, this.state.password.value, USER_SCOPES)
        this.props.parent.setLogin(auth)
      } catch (error) {
        showAlert(getString(error.message), getString('LOGIN_ERROR'))
      }
    }
  }

  renderLogin () {
    return (<div>
      <Dialog
        open={this.state.dialogType === 'login'}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={(event) => {this.login(event)}}>
          <DialogTitle
            id="form-dialog-title">{getString('LOGIN')}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label={getString('EMAIL')}
              required={true}
              type="email"
              error={this.state.email.error}
              helperText={this.state.email.message}
              onChange={(event) => {this.setEmail(event.target.value)}}
              value={this.state.email.value}
              fullWidth
            />
            <TextField
              margin="dense"
              id="password"
              label={getString('PASSWORD')}
              required={true}
              type="password"
              error={this.state.password.error}
              helperText={this.state.password.message}
              onChange={(event) => {this.setPassword(event.target.value)}}
              value={this.state.password.value}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {this.setState(Object.assign({dialogType: 'register'}, this.emptyValues))}}
                    color="secondary">
              {getString('REGISTER')}
            </Button>
            <Button onClick={() => {this.setState(Object.assign({dialogType: 'forgot'}, this.emptyValues))}}
                    color="secondary">
              {getString('FORGOT_TITLE')}
            </Button>
            <Button type='submit' color="primary" variant="contained" size="small">
              {getString('LOGIN')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>)
  }

  async registerUser (event) {
    event.preventDefault()

    if (this.state.activationCode.error || this.state.email.error || this.state.password.error || this.state.password2.error) {
      showAlert(getString('invalid inputs'), getString('REGISTRATION_ERROR'))
    } else {
      try {
        await UserService.registerUser(this.state.activationCode.value, this.state.email.value, this.state.password.value)

        const email = this.state.email.value
        const password = this.state.password.value

        let auth = await UserService.login(email, password, USER_SCOPES)
        this.setState(Object.assign({dialogType: 'login'}, this.emptyValues))
        this.props.parent.setLogin(auth)

        showAlert(getString('REGISTRATION_SUCCESS_TEXT'), getString('REGISTRATION_SUCCESS_TITLE'))
      }
      catch (error) {
        if (['code not found', 'code in use'].indexOf(error.message) >= 0) {
          this.setState({
            activationCode: {
              value: this.state.activationCode.value,
              error: true,
              message: getString(error.message)
            }
          })
        } else if (error.message === 'nickname is used in this group') {
          this.setState({email: {value: this.state.email.value, error: true, message: getString(error.message)}})
        }
        showAlert(getString(error.message), getString('REGISTRATION_ERROR'))
      }
    }
  }

  renderRegister () {
    return (<div>
      <Dialog
        open={this.state.dialogType === 'register'}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={(event) => {this.registerUser(event)}}>
          <DialogTitle
            id="form-dialog-title">{getString('REGISTER')}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="activationCode"
              label={getString('ACTIVATIONCODE')}
              required={true}
              type="text"
              error={this.state.activationCode.error}
              helperText={this.state.activationCode.message}
              onChange={(event) => {this.setActivationCode(event.target.value)}}
              value={this.state.activationCode.value}
              fullWidth
            />
            <TextField
              margin="dense"
              id="email"
              label={getString('EMAIL')}
              required={true}
              type="email"
              error={this.state.email.error}
              helperText={this.state.email.message}
              onChange={(event) => {this.setEmail(event.target.value)}}
              value={this.state.email.value}
              fullWidth
            />
            <TextField
              margin="dense"
              id="password"
              label={getString('PASSWORD')}
              required={true}
              type="password"
              error={this.state.password.error}
              helperText={this.state.password.message}
              onChange={(event) => {this.setPassword(event.target.value)}}
              value={this.state.password.value}
              fullWidth
            />
            <TextField
              margin="dense"
              id="password2"
              label={getString('PASSWORD2')}
              required={true}
              type="password"
              error={this.state.password2.error}
              helperText={this.state.password2.message}
              onChange={(event) => {this.setPassword2(event.target.value)}}
              value={this.state.password2.value}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {this.setState(Object.assign({dialogType: 'login'}, this.emptyValues))}}
                    color="secondary">
              {getString('CANCEL')}
            </Button>
            <Button type="submit" color='primary' variant='contained' size='small'>
              {getString('REGISTER')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>)
  }

  async sendForgot (event) {
    event.preventDefault()
    if (this.state.email.error) {
      showAlert(getString('invalid inputs'), getString('FORGOT_ERROR'))
    } else {
      try {
        let response = await UserService.requestPasswordReset(this.state.email.value)
        showAlert(getString('FORGOT_SEND_SUCCESS', [response['email'], Math.floor(response['maxSeconds'] / 60)]), getString('FORGOT_TITLE'), [{
          label: 'weiter',
          callback: () => {this.setState(Object.assign({dialogType: 'login'}, this.emptyValues))}
        }])
      } catch (error) {
        showAlert(getString(error.message), getString('FORGOT_ERROR'))
      }
    }
  }

  renderForgot () {
    return (<div>
      <Dialog
        open={this.state.dialogType === 'forgot'}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={(event) => {this.sendForgot(event)}}>
          <DialogTitle
            id="form-dialog-title">{getString('FORGOT_TITLE')}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label={getString('EMAIL')}
              required={true}
              type="email"
              error={this.state.email.error}
              helperText={this.state.email.message}
              onChange={(event) => {this.setEmail(event.target.value)}}
              value={this.state.email.value}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {this.setState(Object.assign({dialogType: 'login'}, this.emptyValues))}}
                    color="secondary">
              {getString('CANCEL')}
            </Button>
            <Button type="submit" color="primary" variant="contained" size="small">
              {getString('FORGOT_SEND')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>)
  }

  render () {
    return (
      <div className="App-content">
        {(this.state.dialogType === 'login') && this.renderLogin()}
        {(this.state.dialogType === 'register') && this.renderRegister()}
        {(this.state.dialogType === 'forgot') && this.renderForgot()}
      </div>
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired
}

export default withStyles(styles)(Login)
